import { EnumBase } from 'hay-core-react';
class HomologacaoIntegracaoTipoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.homologacaointegracao.tipo.iris',
                'main.homologacaointegracao.tipo.voalle',
                'main.homologacaointegracao.tipo.portalatendimento',
            ],
            'main.homologacaointegracao.tipo.iris'
        );
    }
}

const instance = new HomologacaoIntegracaoTipoEnum();
export default instance;
